<template>
    <div id="patents-list-view" class="patents-list-view">
        <!--header-->
        <div class="patents-list-head">
            <p v-if="dataList.length" class="patents-list-head__container">
                <template v-if="isNumber(totalApnoNumber)">
                    <p
                        class="patents-list-head__family"
                        v-html="$t('patent-view.familyResult',{
                            apn: totalApnoNumber | number,
                            pn: totalNumber | number
                        })"
                    />
                </template>
                <template v-else>
                    <span class="patents-list-head__number">{{ totalNumber | number }}</span>
                    <span class="patents-list-head__unit">{{ $t('patent-view.Results') }}</span>
                </template>
            </p>
            <p v-else class="patents-list-head__placeholder" />
            <p class="patents-list-head__container">
                <span>{{ $t('patent-view.list-type.'+(viewParams._type || 'query')) }}</span>
                <span v-if="viewParams._type === 'workspace'" class="patents-list-head__list-name">{{ name }}</span>
            </p>
            <button
                v-if="viewParams.source_type === 'innosnap' && dataList.length"
                :disabled="!selectedPatentIdList.length"
                data-type="primary"
                data-size="small"
                class="pt-ui-btn patents-list-head__link-button"
                @click="linkToInnosnap"
            >
                {{ $t('patent-view.linkWithProposal') }}
            </button>
        </div>
        <!--content-->
        <div class="patents-list-scroll">
            <div class="patents-list-content">
                <!--prev-->
                <div v-if="hasPrev === true" class="patents-load patents-load-prev">
                    <PtIcon v-show="loadingPrevVisible" icon="SolidLoadingBars" />
                    <a
                        v-show="!loadingPrevVisible && dataList.length > 0"
                        class="prev-page-btn"
                        @click="loadList('prev')"
                    >
                        &lt;&lt; {{ $t('patent-view["Prev page"]') }}
                    </a>
                </div>
                <!--body-->
                <div class="patents-list-body" :data-current="patentId" :data-rows="rows">
                    <router-link
                        v-for="(data, index) in dataList"
                        :key="data.PATENT_ID"
                        :to="getRouterLink(data)"
                        :data-patentId="data.PATENT_ID"
                        :data-pn="data.PN"
                        class="patents-list-block"
                        :class="{
                            selected: $route.query.patentId === data.PATENT_ID
                        }"
                        tag="div"
                    >
                        <div class="list-title" :data-page="page" flex="-">
                            <span v-if="hasMark" :class="['read-status', data.READ_STATUS ? 'read' : 'unread']" />
                            <span class="list-index">{{ startIndex + index + 1 }}</span>
                            <span v-once class="list-pn">{{ data.PN }}</span>
                            <i :data-cas="`${data.HAS_CAS}`" />
                            <legal
                                :legalObject="data"
                                :callbackParams="{ params: { patentId: data.PATENT_ID, page } }"
                                :withoutPatentList="false"
                                openType="_self"
                                class="legal-status"
                            />
                        </div>
                        <p v-once class="list-desc" v-html="data.TITLE" />
                        <ElCheckbox
                            v-if="hasSelectPatent"
                            :value="selectedPatentIdList.includes(data.PATENT_ID)"
                            class="list-select"
                            @click.native.stop.prevent="setSelectedPatent(data)"
                        />
                        <MultiMonitorToggle
                            :patentId="data.PATENT_ID"
                            :isInPatentList="true"
                            :class="{ 'list-multi-monitor-entry': true, 'list-multi-monitor-entry--with-select': hasSelectPatent }"
                            @click.native="switchPatent(data.PATENT_ID)"
                        />
                    </router-link>
                    <div v-if="dataList.length === 0 && loadingList" class="loading-list">
                        <PtIcon icon="SolidLoadingBars" />
                    </div>
                </div>
                <!--next-->
                <div class="patents-load patents-load-next">
                    <PtIcon v-if="loadingNextVisible" icon="SolidLoadingBars" />
                    <a
                        v-else-if="hasNext && dataList.length && !loadingList"
                        class="next-page-btn"
                        @click="loadList('next')"
                    >
                        {{ $t('patent-view["Next page"]') }} >>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import patentList from './patents-list';

export default patentList;
</script>

<style lang="scss" src="./patents-list.scss">
</style>
